import * as yup from 'yup';
import { RetirementExpenses } from '../../../../../../../ProfileOPL/Goals/goals/Retirement/Retirement.meta';

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  PercentOfLivingExpenses: RetirementExpenses;
  LivingExpenseAmount: number | null;
}

export const DEFAULT_VALUES: FormValues = {
  WhatIfKey: '1800',
  WhatIfType: 1800,
  WhatIfTypeName: 'LivingExpensesChange',
  PercentOfLivingExpenses: RetirementExpenses.E100,
  LivingExpenseAmount: null,
};

export const FORM_SCHEMA = yup.object().shape({
  PercentOfLivingExpenses: yup.number().required('Please select a living expenses amount.'),
  LivingExpenseAmount: yup
    .number()
    .nullable()
    .when('PercentOfLivingExpenses', {
      is: RetirementExpenses.Other,
      then: schema =>
        schema
          .required('Please enter a living expenses amount.')
          .min(1, 'Please enter a valid amount.'),
    }),
});
